module.exports = __webpack_public_path__ + "img/qxl-assessment.b4ea593f.png";